import { FormField } from '../../../../../components/form/FormField';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import Select, { SelectOption } from '@rio-cloud/rio-uikit/Select';
import { ServiceCardRepresentation } from '../../../../../components/dataRepresentation/ServiceCardRepresentation';
import { PaymentPartnerType } from '../../../../../codegen/vehicles';
import {
  getPaymentPartnerType,
  setPaymentPartnerType,
} from '../../../state/onboardingUiSlice';
import { useAppDispatch, useAppSelector } from '../../../../../state/hooks';
import { appConfiguration } from '../../../../../configuration/appConfiguration';
import { getUser } from '../../../../../login/loginSlice';
import { ManualInputCardForm } from './ManualInputCardForm';
import { ChargeAndGoCardForm } from './ChargeAndGoCardForm';
import { PaceCardForm } from './PaceCardForm';

const formByPartner: Record<PaymentPartnerType, React.ReactNode> = {
  [PaymentPartnerType.UtaPayment]: <ManualInputCardForm />,
  [PaymentPartnerType.MockUtaPayment]: <ManualInputCardForm />,
  [PaymentPartnerType.ManChargeAndGoPayment]: <ChargeAndGoCardForm />,
  [PaymentPartnerType.DkvPayment]: <PaceCardForm />,
  [PaymentPartnerType.MockFuelingPayment]: <ManualInputCardForm />,
};

export const ServiceCardForm = () => {
  const dispatch = useAppDispatch();
  const { accountId } = useAppSelector(getUser);
  const { supportedPaymentPartnerTypes, dkvEnabledAccounts } = appConfiguration;

  const paymentPartnerOptions: SelectOption[] = supportedPaymentPartnerTypes
    .filter(
      (paymentPartnerType) =>
        paymentPartnerType !== PaymentPartnerType.DkvPayment ||
        dkvEnabledAccounts.length === 0 ||
        dkvEnabledAccounts.includes(accountId),
    )
    .map((paymentPartnerType) => {
      return {
        id: paymentPartnerType,
        label: (
          <ServiceCardRepresentation
            paymentPartner={paymentPartnerType as PaymentPartnerType}
          />
        ),
      };
    });

  const selectedPaymentPartner = useAppSelector(getPaymentPartnerType);

  return (
    <div
      className={'display-grid grid-cols-8 margin-top-15'}
      data-testid={'onboarding-dialog-body-service-card'}
    >
      <div className={'grid-colspan-8 padding-left-10'}>
        <div className="text-size-16 text-medium margin-bottom-20">
          <CustomFormattedMessage
            id={'onboarding.addServiceCard.dialog.message'}
          />
        </div>
        <div className="row">
          <div
            className="col-xs-12"
            data-testid={'onboarding-dialog-body-serviceCardTypeSection'}
          >
            <FormField>
              <label id={'card-type-label'}>
                {<CustomFormattedMessage id={'common.card.type'} />}
              </label>
              <Select
                aria-labelledby="card-type-label"
                placeholder={
                  <CustomFormattedMessage
                    id={
                      'onboarding.dialog.paymentMethodDetails.selectCardTypePlaceholder'
                    }
                  />
                }
                options={paymentPartnerOptions}
                onChange={(e) => {
                  dispatch(setPaymentPartnerType(e?.id as PaymentPartnerType));
                }}
                value={[selectedPaymentPartner]}
              />
            </FormField>
          </div>

          {selectedPaymentPartner && formByPartner[selectedPaymentPartner]}
        </div>
      </div>
    </div>
  );
};
